import createItemLogic from "./createItemLogic";
import updateItemLogic from "./updateItemLogic";
import deleteItemLogic from "./deleteItemLogic";
import upsertFirebaseObject from "./upsertFirebaseObjectLogic";

export default [...createItemLogic, ...updateItemLogic, ...deleteItemLogic, ...upsertFirebaseObject];
